(function () {
  console.log('[DTF] min-qty script loaded');
  var MIN = 10;
  var nativeSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value'
  ).set;

  function setReactValue(inp, val) {
    nativeSetter.call(inp, val);
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function scan() {
    var inputs = document.querySelectorAll('.gs-w-full.gs-border-none.gs-relative.gs-z-1');
    // The 3 app inputs are always: Width, Height, Quantity (in that order)
    // We target the last one (Quantity)
    if (inputs.length >= 3) {
      var qtyInp = inputs[inputs.length - 1];
      if (qtyInp.tagName === 'INPUT' && Number(qtyInp.value) < MIN) {
        console.log('[DTF] setting quantity from ' + qtyInp.value + ' to ' + MIN);
        setReactValue(qtyInp, MIN);
      }
    }
  }

  setInterval(scan, 400);
})();
